import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import ButtonDropdown from '@ui/components/ButtonDropdown';
const ActionDropdown = ({ row, onUnassign, onSend, onAssign }) => {
    const { t } = useTranslation();
    const assignedName = row.assignedTo?.name?.trim();
    const isAssigned = Boolean(assignedName);
    const assignedOptions = [
        {
            id: 'actions-label',
            text: t('sponsorships.tickets.actionsLabel'),
            disabled: true,
            keepOpen: true,
            group: false
        },
        {
            id: 'unassign',
            text: t('sponsorships.tickets.unassign'),
            group: false,
            to: () => onUnassign(row.id)
        },
        {
            id: 'send-email',
            text: t('sponsorships.tickets.sendEmail'),
            group: true,
            to: () => onSend(row.name, 'email')
        },
        {
            id: 'send-sms',
            text: t('sponsorships.tickets.sendSms'),
            group: true,
            to: () => onSend(row.name, 'sms')
        }
    ];
    const assignOptions = [
        {
            id: 'assign-label',
            text: t('sponsorships.tickets.assignLabel'),
            disabled: true,
            keepOpen: true,
            group: false
        },
        {
            id: 'assign-database',
            text: t('sponsorships.tickets.assignDatabase'),
            group: false,
            to: () => onAssign(row.id, 'database')
        },
        {
            id: 'assign-manual',
            text: t('sponsorships.tickets.assignManual'),
            group: false,
            to: () => onAssign(row.id, 'manual')
        }
    ];
    const options = isAssigned ? assignedOptions : assignOptions;
    const placeholderId = options[0].id ?? '';
    return (_jsx(ButtonDropdown, { label: isAssigned ? t('sponsorships.tickets.actionsLabel') : t('sponsorships.tickets.assignLabel'), options: options, selectedItem: placeholderId, onSelectionChange: () => {
            // keep placeholder selected
        }, variant: 'outlined', color: 'primary', size: 'medium', sx: { textTransform: 'none' } }));
};
export default ActionDropdown;
